import { FullInfoResponse, PaymentFormField } from 'react-easyrocket';
import { setDefalutValue } from './setDefaultValue';

export function prepareDefaultFormState(
  formFields: PaymentFormField[] = [],
  fullInfo: FullInfoResponse | undefined
) {
  return formFields.reduce((result, field) => {
    const value = field.value;
    return { ...result, [field.name]: value || setDefalutValue(field, fullInfo) || '' };
  }, {});
}
